// ======= STEP 2 HEADER REPLACE =======
function replacePersonalizeHeader() {
  const personalizeHeader = document.querySelector('.tee-form-header');
  if (!personalizeHeader) return;
  if (personalizeHeader.querySelector('.step-header')) return;

  personalizeHeader.innerHTML = `
    <div class="step-header">
      <div class="step-num">1</div>
      <div>
        <div class="step-label">Write your letter</div>
        <div class="step-summary">Who is this for?</div>
      </div>
      <div class="step-chevron">∨</div>
    </div>
  `;

  personalizeHeader.querySelector('.step-header').addEventListener('click', function() {
    const form = document.querySelector('.tee-customize-main-form');
    const chevron = personalizeHeader.querySelector('.step-chevron');
    if (!form) return;
    form.classList.toggle('open');
    chevron.style.transform = form.classList.contains('open') ? 'rotate(180deg)' : 'rotate(0deg)';
  });
}

// ======= STEP 2 BY DEFAULT OPEN =======
function initStep2Open() {
  const form = document.querySelector('.tee-customize-main-form');
  if (form) {
    if (!form.classList.contains('open')) {
      form.classList.add('open');
    }
    const chevron = document.querySelector('.tee-form-header .step-chevron');
    if (chevron) chevron.style.transform = 'rotate(180deg)';
  } else {
    setTimeout(initStep2Open, 300);
  }
}

replacePersonalizeHeader();
initStep2Open();
injectStep4();

const personalizeObserver = new MutationObserver(() => {
  replacePersonalizeHeader();
  initStep2Open();
  injectStep4();
});
personalizeObserver.observe(document.body, { childList: true, subtree: true });

// ======= STEP 1 TOGGLE =======
function toggleStep(id) {
  const step = document.getElementById(id);
  if (!step) return;
  const isOpen = step.classList.contains('open');
  
  if (id === 'step4') {
    step.classList.toggle('open');
  } else {
    // step4 ko chhodo, baaki sab close karo
    document.querySelectorAll('.step:not(#step4)').forEach(s => s.classList.remove('open'));
    if (!isOpen) step.classList.add('open');
  }
}
function getProductPrice() {
  const priceEl = document.querySelector('.price__regular .price');
  if (priceEl) return priceEl.innerText.trim();
  return '';
}
function injectStep4() {
  const teeFormActions = document.getElementById('teeFormActions');
  if (!teeFormActions) return;
  if (document.getElementById('step4')) return;

  const rawPrice = getProductPrice();

  // Step 4 card
  const step4 = document.createElement('div');
  step4.className = 'step active open';
  step4.id = 'step4';
  step4.innerHTML = `
    <div class="step-header" onclick="toggleStep('step4')">
      <div class="step-num">2</div>
      <div>
        <div class="step-label">Review &amp; add to cart</div>
        <div class="step-summary">Almost done</div>
      </div>
      <div class="step-chevron">∨</div>
    </div>
    <div class="step-body">
      <div class="field-note" style="margin-bottom:14px;font-size:13px;color:#4A4640;line-height:1.6;">Everything looks good? We'll print your letter on 200 gsm matte paper, frame it in your chosen wood, and deliver it tracked wrapped to protect it.</div>
      <div style="margin-bottom:15px;background:#F7F2EA;border:.5px solid rgba(28,26,23,.08);border-radius:8px;padding:14px 16px;">
        <div style="font-size:11px;letter-spacing:1.5px;text-transform:uppercase;color:rgba(28,26,23,.35);font-weight:500;margin-bottom:10px;">What's included</div>
        <div style="display:flex;flex-direction:column;gap:7px;">
          <div style="font-size:13px;color:#4A4640;font-weight:300;display:flex;align-items:center;gap:8px;"><span style="color:#7A9E8E;font-size:14px;">✓</span> Letter printed on 200 gsm FSC-certified paper</div>
          <div style="font-size:13px;color:#4A4640;font-weight:300;display:flex;align-items:center;gap:8px;"><span style="color:#7A9E8E;font-size:14px;">✓</span> Solid pine magnetic hanger</div>
          <div style="font-size:13px;color:#4A4640;font-weight:300;display:flex;align-items:center;gap:8px;"><span style="color:#7A9E8E;font-size:14px;">✓</span> Tracked delivery, gift-wrapped</div>
          <div style="font-size:13px;color:#4A4640;font-weight:300;display:flex;align-items:center;gap:8px;"><span style="color:#7A9E8E;font-size:14px;">✓</span> A small handwritten note from us</div>
        </div>
      </div>
    </div>
  `;

  // Order summary alag element — step4 ke baad
  const orderSummary = document.createElement('div');
  orderSummary.className = 'order-summary';
  orderSummary.id = 'order-summary';
  orderSummary.innerHTML = `
    <div class="os-label">Order summary</div>
    <div class="os-row">
      <span class="os-label-item">Physical letter — A4</span>
      <span class="os-val">${rawPrice}</span>
    </div>
    <div class="os-row">
      <span class="os-label-item">Pine wood hanger</span>
      <span class="os-val">Included</span>
    </div>
    <div class="os-row">
      <span class="os-label-item">Tracked delivery</span>
      <span class="os-val">Included</span>
    </div>
    <div class="os-row os-row--total">
      <span class="os-label-item os-total">Total</span>
      <span class="os-val os-total">${rawPrice}</span>
    </div>
  `;

  teeFormActions.parentNode.insertBefore(step4, teeFormActions);
  teeFormActions.parentNode.insertBefore(orderSummary, teeFormActions);
}

document.querySelectorAll('.product-details h1, .view-product-title .link').forEach(el => {
    const words = el.innerText.trim().split(' ');
    const normal = words.slice(0, -2).join(' ');
    const styled = words.slice(-2).join(' ');
    el.innerHTML = normal + ' <span style="font-style:italic;color:#C4622D;">' + styled + '</span>';
  });

    function autoResize(el) {
    el.style.setProperty('height', '0', 'important');
    el.style.setProperty('height', el.scrollHeight + 'px', 'important');
  }

  function initTextarea(el) {
    if (el.dataset.autoResize) return;
    el.dataset.autoResize = true;
    el.addEventListener('input', () => autoResize(el));
    setTimeout(() => autoResize(el), 200); // CSS settle hone do
  }

  const observer = new MutationObserver(() => {
    document.querySelectorAll('textarea.tee__paragraph').forEach(initTextarea);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  